(function(){
  document.addEventListener('DOMContentLoaded', function() {
      console.log(1243);

    window.colorSelector = function colorSelector() {
      let selectColor = document.querySelector('.wrapper_color_drop .action_choise');
      if ( ! selectColor ) return false;

      selectColor.addEventListener('click', function(e) {
        e.preventDefault();
        this.classList.toggle('active');
      });

      
      let colorItems = document.querySelectorAll('.wrapper_color_drop .radio_color_swatch[data-name]');
      colorItems.forEach(elem => {
        elem.addEventListener('click', function(e) {
          e.preventDefault();
          
          let color = elem.getAttribute('data-name');
          let swatchValue = document.querySelector(`[type="radio"][value="${color}"]+label[data-name="${color}"]`);
          console.log(swatchValue);
          selectColor.querySelector('.selected_value').innerHTML = color;
          selectColor.classList.toggle('active');
          swatchValue.click();
        });
      });
      

      document.addEventListener('change', function(e) {
        if (e.target.matches('.product-form__input--swatch [type="radio"]')) {
          let elem = e.target;
          
          selectColor.querySelector('.selected_value').innerHTML = elem.value;
        }
      });
    }
    window.colorSelector();
    
    
    // Pass single element
    let select = document.querySelector('.product-form__input--dropdown select');
    if ( select ) {
      let choices = new Choices(select, {
        itemSelectText: '',
      });

      select.addEventListener('change', function(e) {
        console.log(select.value);

        let swatchValue = document.querySelector(`[type="radio"][value="${select.value}"]`);
        swatchValue.click();
      });

      document.addEventListener('change', function(e) {
        if (e.target.matches('.product-form__input--swatch [type="radio"]')) {
          let elem = e.target;
          select.value = elem.value;

          select.dispatchEvent(new Event('change'))
          choices.destroy();
          choices = new Choices(select, {
            itemSelectText: '',
          });
        }
      });
      
    }

    let newsletterPhone = document.querySelectorAll('.footer__newsletter');
    if ( newsletterPhone ) {
      newsletterPhone.forEach(elem => {
        elem.addEventListener('submit', function(e) {
          e.preventDefault();
          
          let tags = elem;
          let tagsInput = elem.querySelector('[name="contact[tags]"]');
          let phone = elem.querySelector('[name="contact[phone]"]');
          let email = elem.querySelector('[name="contact[email]"]').value;
          if ( !tagsInput ) return false;
          let tagsVal = tagsInput.value;
          tagsVal += ', ' + phone.value;
          tagsInput.value = tagsVal;

       
          // var request = new XMLHttpRequest();
          // request.open('POST', 'https://api.flashy.app/contact');
          // request.setRequestHeader('Content-Type', 'application/json');
          
          // request.onreadystatechange = function () {
          //   if (this.readyState === 4) {
          //     console.log('Status:', this.status);
          //     console.log('Headers:', this.getAllResponseHeaders());
          //     console.log('Body:', this.responseText);
          //   }
          // };
          
          // var body = {
          //   'primary_key': 'email',
          //   'overwrite': false,
          //   'contact': {
          //     'email': email,
          //     'phone': phone.value,
          //     'first_name': '',
          //     'last_name': '',
          //   }
          // };
          
          // request.send(JSON.stringify(body));
          elem.submit();
          
        });
      });
      
    }
    window.colorSwiper = function colorSwiper() {
      if ( window.innerWidth > 750 ) return false;
      let colorsSwatch = document.querySelectorAll('product-info variant-selects .product-form__input.product-form__input--swatch .swatch_line');
      if ( colorsSwatch ) {
        let colorsSwiper =  new Swiper(colorsSwatch[0], {
          slidesPerView: 'auto',
          spaceBetween: 15,
          breakpoints: {
            1: {
              freeMode: {
                enabled: true
              },
              scrollbar: {
                el: '.swiper-scrollbar-picker',
                draggable: true,
              },
            },
            768: { 
              navigation: {
                nextEl: '.swiper-button-next-picker',
                prevEl: '.swiper-button-prev-picker',
              },
            }
          }
        });
      }
    }
    window.colorSwiper();

    let properties = document.querySelectorAll('product-info .swiper.swiper_properties');
    if ( properties ) {
      let colorsSwiper =  new Swiper(properties[0], {
        slidesPerView: 3,
        spaceBetween: 15,
         navigation: {
          nextEl: '.swiper-button-next-properties',
          prevEl: '.swiper-button-prev-properties',
        },
        breakpoints: {
          1: {
            freeMode: {
              enabled: true
            },
            scrollbar: {
              el: '.swiper-scrollbar-properties',
              draggable: true,
            },
          }
        }
      });
    }
   
  }, false);
})();